import React from "react";
import { Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { CustomCard } from "../../CustomCard";

// styles
import useStyles from "./styles";

const MPISummaryCardSkeleton = ({ index }) => {
  const styles = useStyles();

  return (
    <CustomCard
      key={`SummaryCardSkeletonLoader-${index}`}
      className={styles.card}
      borderRadius="xl"
      borderColor="secondary"
      boxShadow="xs"
    >
      <Box className={styles.container}>
        <Box className={styles.leftSection}>
          <Skeleton width={90} height={24} variant="text" />
          <Box className={styles.saleInfo}>
            <Skeleton width={50} height={18} variant="text" />
            <Skeleton
              width={20}
              height={20}
              variant="circle"
              style={{ margin: "0 4px 0 12px" }}
            />
          </Box>
        </Box>

        <Box className={styles.middleSection}>
          <Box className={styles.medianSizeBox}>
            <Skeleton
              width={20}
              height={20}
              variant="circle"
              style={{ marginRight: 4 }}
            />
            <Skeleton width={120} height={18} variant="text" />
          </Box>
          <Skeleton
            width={160}
            height={18}
            variant="text"
            style={{ marginTop: 4 }}
          />
        </Box>

        <Box className={styles.adsBox}>
          <Skeleton
            width={24}
            height={24}
            variant="circle"
            style={{ marginRight: 4 }}
          />
          <Skeleton width={90} height={18} variant="text" />
        </Box>

        <Box className={styles.priceBox}>
          <Skeleton width={160} height={28} variant="text" />
        </Box>

        <Box
          style={{
            marginTop: 12,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Skeleton
            width={260}
            height={44}
            variant="rect"
            style={{ borderRadius: 8 }}
          />
        </Box>
      </Box>
    </CustomCard>
  );
};

export default MPISummaryCardSkeleton;
